import React from 'react';
import { LocationDetails } from '../CreateChargePoint/types';

export interface CreateLocationContextValue {
  onCreated: (location: LocationDetails) => void;
}

export const CreateLocationContext = React.createContext<CreateLocationContextValue>({
  onCreated: () => {},
});
